// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content_header {
  gap: 2em;
  padding: 1em;
  display: flex;
  color: #294ADB;
  align-items: center;
  justify-content: center;
  background-color: rgb(235, 235, 235);
}
.content_header mat-label {
  font-size: 1.5rem;
}

.mat-mdc-dialog-actions {
  flex-direction: row-reverse;
  justify-content: right;
  margin-right: 3%;
  margin-bottom: 1%;
}

.container-without-results {
  display: flex;
  justify-content: center;
  font-size: 18px;
  margin-top: 20px;
}

mat-grid-list {
  margin: 0 3%;
}
mat-grid-list mat-grid-tile {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  text-align: center;
}
mat-grid-list mat-grid-tile .logo {
  width: 40px;
  height: 40px;
  object-fit: contain;
}
mat-grid-list mat-grid-tile span {
  margin-top: 0.3rem;
  font-size: 0.9rem;
  text-align: center;
}
mat-grid-list mat-grid-tile mat-checkbox {
  margin-top: 0.3rem;
}
mat-grid-list mat-grid-tile:hover {
  background: #f5f5f5;
  transition: background-color 100ms linear;
}
mat-grid-list ::ng-deep mat-grid-tile .mat-grid-tile-content {
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
mat-grid-list .lighting:hover {
  color: #5b0763;
}
mat-grid-list .installers:hover {
  color: #5b0763;
}
mat-grid-list .chargers:hover {
  color: #84B343;
}
mat-grid-list .monitoring:hover {
  color: #84B343;
}
mat-grid-list .suppliers:hover {
  color: #458539;
}

/* responsive desgin */
@media (max-width: 768px) {
  mat-grid-list mat-grid-tile {
    font-size: 11px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/dialogs/inicializador-apps/inicializador-apps.component.scss"],"names":[],"mappings":"AAAA;EACI,QAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;AACJ;AACI;EACI,iBAAA;AACR;;AAGA;EACI,2BAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,YAAA;AAAJ;AAEI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AAAR;AAEQ;EACI,WAAA;EACA,YAAA;EACA,mBAAA;AAAZ;AAGQ;EACI,kBAAA;EACA,iBAAA;EACA,kBAAA;AADZ;AAIQ;EACI,kBAAA;AAFZ;AAMI;EACI,mBAAA;EACA,yCAAA;AAJR;AAOI;EACI,sBAAA;EACA,mBAAA;EACA,uBAAA;AALR;AASI;EACI,cAAA;AAPR;AAUI;EACI,cAAA;AARR;AAWI;EACI,cAAA;AATR;AAYI;EACI,cAAA;AAVR;AAaI;EACI,cAAA;AAXR;;AAeA,sBAAA;AACA;EAGQ;IACI,eAAA;EAdV;AACF","sourcesContent":[".content_header{\r\n    gap: 2em;\r\n    padding: 1em;\r\n    display: flex;\r\n    color: #294ADB;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background-color: rgb(235, 235, 235);\r\n\r\n    mat-label {\r\n        font-size: 1.5rem;\r\n    }\r\n}\r\n\r\n.mat-mdc-dialog-actions {\r\n    flex-direction: row-reverse;\r\n    justify-content: right;\r\n    margin-right: 3%;\r\n    margin-bottom: 1%;\r\n}\r\n\r\n.container-without-results {\r\n    display: flex;\r\n    justify-content: center;\r\n    font-size: 18px;\r\n    margin-top: 20px;\r\n}\r\n\r\nmat-grid-list {\r\n    margin: 0 3%;\r\n    \r\n    mat-grid-tile {\r\n        display: flex;\r\n        flex-direction: column;\r\n        align-items: center;\r\n        justify-content: center;\r\n        cursor: pointer;\r\n        text-align: center;\r\n\r\n        .logo {\r\n            width: 40px;\r\n            height: 40px;\r\n            object-fit: contain;\r\n        }\r\n\r\n        span {\r\n            margin-top: 0.3rem;\r\n            font-size: 0.9rem;\r\n            text-align: center;\r\n        }\r\n\r\n        mat-checkbox {\r\n            margin-top: 0.3rem;\r\n        }\r\n    }\r\n\r\n    mat-grid-tile:hover {\r\n        background: #f5f5f5;\r\n        transition: background-color 100ms linear;\r\n    }\r\n\r\n    ::ng-deep mat-grid-tile .mat-grid-tile-content {\r\n        flex-direction: column;\r\n        align-items: center;\r\n        justify-content: center;\r\n    }\r\n \r\n\r\n    .lighting:hover {\r\n        color: #5b0763;\r\n    }\r\n\r\n    .installers:hover {\r\n        color: #5b0763;\r\n    }\r\n\r\n    .chargers:hover {\r\n        color: #84B343;\r\n    }\r\n    \r\n    .monitoring:hover {\r\n        color: #84B343;\r\n    }\r\n\r\n    .suppliers:hover {\r\n        color: #458539;\r\n    }\r\n}\r\n\r\n/* responsive desgin */\r\n@media (max-width: 768px) {\r\n\r\n    mat-grid-list {\r\n        mat-grid-tile {\r\n            font-size: 11px;\r\n        }\r\n    }\r\n\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
